import { TransactionStatusMeta, normalizeStatus } from "./TransactionStatus";

export default function StatusBadge({ status }) {
  const norm = normalizeStatus(status);
  const meta = TransactionStatusMeta[norm] || { label: norm || "UNKNOWN", badgeClass: "bg-secondary" };
  return (
    <span className={`badge ${meta.badgeClass}`} style={{ fontSize: ".8rem" }}>
      {meta.label}
    </span>
  );
}
